<template>
  <ion-row>
    <ion-col class="text-center">
      <ion-icon
        src="/assets/security/security-icon-sms.svg"
        class="w-[80px] h-[80px] fadein-300 mb-2"
        v-if="headerIcon == 'sms'"
      ></ion-icon>
      <ion-icon
        src="/assets/security/security-icon-email.svg"
        class="w-[80px] h-[80px] fadein-300 mb-2"
        v-else-if="headerIcon == 'email'"
      ></ion-icon>
      <ion-icon
        src="/assets/security/security-icon-mfa.svg"
        class="w-[80px] h-[80px] fadein-300 mb-2"
        v-else
      ></ion-icon>
    </ion-col>
  </ion-row>
</template>
<script setup>
import { computed } from "vue";
import { useCustomerStore } from "@/stores";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
const route = useRoute();
const path = computed(() => route.path);
const customerStore = useCustomerStore();
const { mfaOptionSelected, mfaLoginType } = storeToRefs(customerStore);
const headerIcon = computed(() =>
  path.value.includes("mfa-updated")
    ? 'default'
    : mfaLoginType.value
    ? mfaLoginType.value
    : mfaOptionSelected.value
);
</script>
